/* eslint-disable camelcase */
import { isObject, isString, isArray } from 'typechecker'

export type CountrySuggestionArgument = {
  code?: string
  title_i18n?: string
  collections?: string[]
  img?: string
  storeInventories?: StoreInventory[]
  comments?: Comment[]
  overviews?: Overview[]
  mostPopularCity?: MostPopularCity
}

type BlogPost = {
  title: string
  link: string
  img: string
}

type StoreInventory = {
  storeName: string
  storeId: number
  count: number
}

type Comment = {
  store_comment: string
  store_score_all: number
  name: string
  brand: string
}

type Overview = {
  title: string
  content: string
}

type MostPopularCity = {
  id: number;
  suggestion_country_id: number;
  title_i18n: string;
  img: string;
  sort: number;
  lat: number;
  lng: number;
  max_distance: number;
  url_path: string;
  enabled: number;
  created_at: string;
  updated_at: string;
  location?: string;
  country?: string;
};

export default class CountrySuggestion {// 國家城市共用
  code?: string

  /** 國家i18n */
  title_i18n?: string;

  /** 國家 */
  country?: string

  /** 車款 */
  collections: string[] = []

  /** 店家即時庫存 */
  storeInventories: StoreInventory[] = []

  /** 評論 */
  comments: Comment[] = []

  /** 國家PickUp城市 */
  mostPopularCity?: MostPopularCity

  /** 租車攻略 */
  overviews: Overview[] = []

  /** 國家圖片 */
  img?: string

  constructor (suggestion: CountrySuggestionArgument) {
    if (!isObject(suggestion)) throw new TypeError('`suggestion` must be an object!')

    if (isString(suggestion.code)) this.code = suggestion.code
    if (isString(suggestion.title_i18n)) this.title_i18n = suggestion.title_i18n
    if (suggestion.collections && isArray(suggestion.collections)) this.collections = suggestion.collections
    if (suggestion.storeInventories && isArray(suggestion.storeInventories)) this.storeInventories = suggestion.storeInventories
    if (suggestion.comments && isArray(suggestion.comments)) this.comments = suggestion.comments
    if (suggestion.overviews && isArray(suggestion.overviews)) this.overviews = suggestion.overviews
    if (suggestion.mostPopularCity) this.mostPopularCity = suggestion.mostPopularCity
    if (suggestion.img) this.img = suggestion.img
  }
}
